<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div v-if="!data.categoryId" class="tinylist-container categorylist-container">
      <component v-for="category in categories" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="category.id" :title="category.name" :is="getCategoryComponent(category)" :category="category" v-on:openCategory="openCategory"></component>
    </div>
    <div v-else>
      <div class="tinylist-container categorylist-container">
        <component :column="column" :activeComponent="component" :baseDomain="baseDomain" :is="getHeaderComponent()" :title="getCategoryTitle()" :category="false" v-on:closeCategory="closeCategory"></component>
      </div>
      <div class="card-items">
      <component v-for="product in products" :allowResourceSelection="true" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="product.id + '-' + product.shopid" :is="getProductComponent(product)" :product="product.product" :productShopId="product.shopid" v-on:openLinkedCategories="openLinkedCategories" :displayName="displayName">
        {{ product.name }}
      </component>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { BuyableProductListItem, CategoryListItem, ReservableProductListItem, ContentProductListItem, InvalidProductListItem } from '#components'
import products from '~/lib/products'
import constants from '~/lib/constants'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      categories: [],
      products: [],
      subProducts: [],
      previousParents: [],
      data: {
        categoryId: null,
        categoryTitle: null
      }
    }
  },
  mixins: [components, products, constants],
  methods: {
    getCategoryComponent (category) {
      return 'CategoryListItem'
    },
    getHeaderComponent () {
      return 'CategoryListItem'
    },
    setActiveComponent (component) {
      this.reset()
      this.$emit('setActiveComponent', component)
    },
    reset () {
      this.data.categoryId = null
      this.data.categoryTitle = null
      this.products = []
      this.previousParents = []
    },
    loadCategories () {
      let $this = this
      const params = {
        details: true,
        sorters: [{
          field: 'name',
          dir: 'asc'
        }]
      }
      axios.get(this.baseDomain + this.shopId + '/categories.json', { params })
      .then(function (response) {
        $this.categories = response.data.filter((cat) => {
          return !!parseInt(cat.enable_pos)
        })
      })
      .catch(function (e) {
        console.log('Failed to load categories.')
      })
    },
    parseProducts() {
      this.products = this.products.filter((product) => parseInt(product?.subtype, 10) !== this.SUBTYPE_TICKET && !parseInt(product?.deleted, 10) && !parseInt(product?.archived, 10))
    },
    openCategory () {
      this.products = []
      this.previousParents.push([arguments[0],arguments[1]])
      let categoryId = arguments[0]
      let categoryTitle = arguments[1]
      this.data.categoryId = categoryId
      this.data.categoryTitle = categoryTitle
      this.loadProducts(this.parseProducts)
    },
    openPreviousCategory () {
      this.products = []
      let previousArgs = this.previousParents.pop()
      let categoryId = previousArgs[0]
      let categoryTitle = previousArgs[1]
      this.data.categoryId = categoryId
      this.data.categoryTitle = categoryTitle
      this.loadProducts(this.parseProducts)
    },
    openLinkedCategories () {
      this.products = []
      let productId = arguments[0]
      let productShopId = arguments[1]
      let categoryIds= arguments[2]
      let categoryTitle = arguments[3]
      this.previousParents.push([arguments[0],arguments[1],arguments[2],arguments[3]])
      let cats = categoryIds.map(cId => { return {shopId:productShopId, id:cId}})
      this.data.categoryIds = cats
      this.data.categoryTitle = categoryTitle
      this.loadLinkedCategories(this.parseProducts)
    },
    openPreviousLinkedCategories () {
      this.products = []
      let previousArgs = this.previousParents.pop()
      let productId = previousArgs[0]
      let productShopId = previousArgs[1]
      let categoryIds= previousArgs[2]
      let categoryTitle = previousArgs[3]
      let cats = categoryIds.map(cId => { return {shopId:productShopId, id:cId}})
      this.data.categoryIds = cats
      this.data.categoryTitle = categoryTitle
      this.loadLinkedCategories(this.parseProducts)
    },
    closeCategory () {
      this.previousParents.pop()
      if(this.previousParents.length == 1) {
        this.openPreviousCategory()
        return
      }
      if(this.previousParents.length == 0) {
        this.reset()
        this.loadCategories()
        return
      }
      this.openPreviousLinkedCategories()
    },
    getCategoryTitle() {
      return this.data.categoryTitle
    }
  },
  components: {
    CategoryListItem,
    BuyableProductListItem,
    ReservableProductListItem,
    ContentProductListItem,
    InvalidProductListItem
  },
  computed: {
    displayName() {
      return JSON.parse(this.component.data) && JSON.parse(this.component.data).displayName ? JSON.parse(this.component.data).displayName : ''
    }
  },
  mounted () {
    this.loadCategories()
    if(!this.events) {
      let events = {}
      events['categoryUpdate'] = debounce((message) => {
        if (message.shopId === this.shopId) {
          this.loadCategories()
        }
      }, 200)
      events['productUpdate'] = debounce((message) => {
        for (var i = 0; i < this.products.length; i++) {
          let product = this.products[i]
          if (product.shopid == message.shopId && product.source_id == message.data.id) {
            this.loadProduct(product.shopid, product.source_id)
          }
        }
      }, 200)
      events['availabilityUpdate'] = debounce((message) => {
        for (var i = 0; i < this.products.length; i++) {
          let product = this.products[i]
          if (product.shopid == message.shopId && message.data && message.data.affectedProducts && message.data.affectedProducts.indexOf(parseInt(product.source_id, 10)) !== -1) {
            this.loadProduct(product.shopid, product.source_id)
          }
        }
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>